module.exports = __webpack_public_path__ + "static/media/new-new-pytorch.a4f674ef.svg";